import * as rq from '@tanstack/react-query';

import { useDependencies } from '@/api/fe-api/contexts/dependencies.context';
import type { ICapacityEvaluationRepository } from '@/api/fe-api/domain/repositories/capacity-evaluation.repository';

export namespace GetAggregatedResults {
  export const key = (input: Input) => [
    'capacity-evaluation',
    'get-aggregated-results',
    ...Object.entries(input).flatMap(([key, value]) => [key, value]),
  ];

  export type Params = { refetchInterval?: number };
  export type Input = ICapacityEvaluationRepository.GetAggregatedResultsInput;
  export type Output = ICapacityEvaluationRepository.GetAggregatedResultsOutput;

  export function useQuery(input: Input, { refetchInterval }: Params = {}) {
    const { repositories } = useDependencies();

    return rq.useQuery<Output>({
      refetchInterval,
      queryKey: key(input),
      queryFn: () =>
        repositories.capacityEvaluation.getAggregatedResults(input),
    });
  }
}
